/**
 * Scales distance of coordinate piece relative to origin by ratio
 * @param value {number} - lat or long
 * @param origin {number} - lat or long for center coordinate to scale relative to
 * @param ratio - scale factor, 1 - keep the same, > 1 - increase, < 1 - decrease
 * @returns {number}
 */
export var scaleFromOrigin = function scaleFromOrigin(value, origin, ratio) {
  return origin + (value - origin) * ratio;
};